/**
 * Convert UTC dates from the API to Eastern (America/New_York) for display.
 * API returns UTC (e.g. ISO strings with Z); we display in Eastern.
 */
const EASTERN_TZ = 'America/New_York';

/**
 * @param {string|Date|null|undefined} date - UTC date from API (ISO with Z) or Date
 * @param {{ long?: boolean }} options - long: "Wednesday, April 1, 2026", else short
 * @returns {string} Date formatted in Eastern, or '—' if invalid
 */
export function formatUTCDateToEastern(date, options = {}) {
  if (date == null) return '—';
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', {
    timeZone: EASTERN_TZ,
    year: 'numeric',
    month: options.long ? 'long' : 'numeric',
    day: 'numeric',
    ...(options.long && { weekday: 'long' })
  });
}
